import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { signOut } from "firebase/auth";
import { auth } from "../authentication/firebase";
import { useSelector } from "react-redux";

const ProfileInfo = () => {
  const navigate = useNavigate();
//   const user = useSelector((state) => state.user.currentUser);
const user = auth.currentUser

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // Mock rank data - you can replace this with actual user rank logic
  const userRank = {
    level: 13,
    title: "Tree Guardian",
    progress: 3, // out of 5
    description: "You are on 3 days contribution streak!"
  };

  const renderRankIcons = () => {
    const icons = [];
    for (let i = 0; i < 5; i++) {
      icons.push(
        <RankIcon key={i} active={i < userRank.progress}>
          🌟
        </RankIcon>
      );
    }
    return icons;
  };

  return (
    <ProfileInfoContainer>
      <ProfileAvatar>
        <AvatarImage>
          {user?.photoURL ? (
            <img src={user.photoURL} alt="Profile" />
          ) : (
            <DefaultAvatar>
              {user?.displayName?.charAt(0) || user?.email?.charAt(0) || "U"}
            </DefaultAvatar>
          )}
        </AvatarImage>
        <RankBadge>{userRank.level}</RankBadge>
      </ProfileAvatar>

      <ProfileDetails>
        <UserName>{user?.displayName || "User"}</UserName>
        <UserEmail>{user?.email}</UserEmail>
        <RankTitle>{userRank.title}</RankTitle>
        
        <RankSection>
          <RankIcons>{renderRankIcons()}</RankIcons>
          <RankDescription>{userRank.description}</RankDescription>
        </RankSection>

        <LogoutButton onClick={handleLogout}>
          Logout
        </LogoutButton>
      </ProfileDetails>
    </ProfileInfoContainer>
  );
};

const ProfileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 400px;
`;

const ProfileAvatar = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
`;

const AvatarImage = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 4px solid #e8f5e8;
  overflow: hidden;
  position: relative;
  background: linear-gradient(135deg, #a8e6cf 0%, #88d8a3 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const DefaultAvatar = styled.div`
  font-size: 3rem;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
`;

const RankBadge = styled.div`
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: #a8e6cf;
  color: #2d5a3d;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.1rem;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

const UserName = styled.h2`
  font-size: 1.8rem;
  color: #333;
  margin: 0;
  font-weight: 600;
`;

const UserEmail = styled.p`
  color: #666;
  font-size: 1rem;
  margin: 0;
`;

const RankTitle = styled.h3`
  color: #2d5a3d;
  font-size: 1.2rem;
  margin: 0.5rem 0;
  font-weight: 500;
`;

const RankSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
`;

const RankIcons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const RankIcon = styled.span`
  font-size: 1.5rem;
  opacity: ${props => props.active ? 1 : 0.3};
  transition: opacity 0.3s ease;
  filter: ${props => props.active ? 'none' : 'grayscale(100%)'};
`;

const RankDescription = styled.p`
  color: #555;
  font-size: 0.9rem;
  margin: 0;
  text-align: center;
  max-width: 250px;
`;

const LogoutButton = styled.button`
  color: #ff4444;
  /* color: white; */
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  transition: background-color 0.3s ease;
  margin-top: 1rem;

  &:hover {
    background-color: #ff0000;
    color: white;
  }
`;

export default ProfileInfo; 